import React, { useState, useEffect } from "react";
import { flushSync } from "react-dom";
import { Row, Col, Card, CardBody, Table, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import "../ExternalOrganisation/ExternalOrganisation.css";
import Select, { components, ValueContainerProps } from 'react-select';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const UserVineyard = ({ refreshToken }) => {
    const [userFarmList, setUserFarmList] = useState([]);
    const [tempUserFarms, setTempUserFarms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userSelect, setUserSelect] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [userFarms, setUserFarms] = useState([]);
    const [saveDisabled, setSaveDisabled] = useState(false);
    const [masterCheck, setMasterCheck] = useState(false);
    const [userListFilter, setUserListFilter] = useState({ filteredUserList: [], selectedRole: 0, isOrganisationShow: false, selectedOrganisation: 0, isCertifier: false, isAuditor: false });
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/settings/getuserfarms/', {
                params: {}
            }
            );
            setUserFarmList(response.data.content);
            setUserListFilter({ ...userListFilter, filteredUserList: response.data.content.users })
            setUserFarms([]);
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const handleUserChange = async (event) => {
        setUserSelect(event);
        if (event != null) {
            const response = userChange(event.value);
            toast.promise(response, {
                loading: 'Loading...',
                success: '',
                error: 'Error while loading data',
            });

        }
        else {
            setUserFarms([]);
            setSaveDisabled(true);
        }
        refreshToken();
    }

    const userChange = async (userId) => {
        const response = await apiGet(
            '/api/settings/UserChange/', {
            params: { Id: userId }
        }
        );
        if (response.data.status) {
            setUserFarms(response.data.content);
            setTempUserFarms(response.data.content);
            setSaveDisabled(false);
        }
    }

    const onItemCheck = async (e, item1, type) => {
        let tempList = userFarms;
        if (type == 'farmAccess') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.farmAccess = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddArchiveItem') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddArchiveItem = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddEditItem') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddEditItem = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'saveRightsForNonItemFieldsAndTables') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.saveRightsForNonItemFieldsAndTables = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isCreateNewAction') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isCreateNewAction = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isSubmitEvidenceCloseAction') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isSubmitEvidenceCloseAction = e.target.checked;
                }
                return userFarm;
            });
        }
        else if (type == 'isAddDeleteDocument') {
            tempList.map((userFarm) => {
                if (userFarm.farmId === item1.farmId) {
                    userFarm.isAddDeleteDocument = e.target.checked;
                }
                return userFarm;
            });
        }

        flushSync(() => {
            setUserFarms(prevUserFarms => {
                const newUserFarms = [...prevUserFarms];
                return newUserFarms;
            });
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaveDisabled(true);
        let form = {
            UserId: userSelect.value,
            Farms: [],
            ChangedUserId: userId
        }
        for (var i = 0; i < tempUserFarms.length; i++) {
            var obj = {};
            obj.FarmId = tempUserFarms[i].farmId;
            var userFarm = userFarms.filter(x => x.farmId == tempUserFarms[i].farmId)[0];
            obj.FarmAccess = userFarm == undefined ? tempUserFarms[i].farmAccess : userFarm.farmAccess;
            obj.Role = tempUserFarms[i].role;
            obj.Position = tempUserFarms[i].position;
            obj.AccessExpiryText = tempUserFarms[i].accessExpiry != null ? tempUserFarms[i].accessExpiryText : "";
            form.Farms.push(obj);
        }
        const response = await apiPost(
            '/api/settings/SaveUserFarms/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("User Farm Associations Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSaveDisabled(false);
                const response1 = userChange(userSelect.value);
                toast.promise(response1, {
                    loading: 'Loading...',
                    success: '',
                    error: 'Error while loading data',
                });
                setName('');
            }
        }
        refreshToken();
    }

    const onMasterCheck = async (e) => {
        let tempList = userFarms;
        tempList.map((item) => (item.farmAccess = e.target.checked));
        flushSync(() => {
            setMasterCheck(e.target.checked);
            setUserFarms(prevUserFarms => {
                const newUserFarms = [...prevUserFarms];
                return newUserFarms;
            });
        });
    }
    const [name, setName] = useState('');
    const handleChangeName = async (event) => {
        setName(event.target.value);
        var list = [];
        list = tempUserFarms;
        list = tempUserFarms.filter(x => (x.farmUniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) || x.farmname.toLowerCase().includes(event.target.value.toLowerCase())));
        setUserFarms(list);
    }

    const style = {
        table: {
            width: '100%',
            display: 'table',
            borderSpacing: 0,
            borderCollapse: 'separate',
        },
        th: {
            top: 0,
            left: 0,
            zIndex: 2,
            position: 'sticky',
            backgroundColor: '#fff',
        },
    };

    const handleRoleChange = idx => e => {
        const tempRows = [...userFarms];
        tempRows[idx].role = parseInt(e.target.value);
        setUserFarms(tempRows);
    };
    const handlePositionChange = idx => e => {
        const tempRows = [...userFarms];
        tempRows[idx].position = e.target.value;
        setUserFarms(tempRows);
    };

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const handleAccessExpiryDateChange = (idx, date) => {
        const tempRows = [...userFarms];
        tempRows[idx].accessExpiryText = getParsedDate(date);
        tempRows[idx].accessExpiry = getDateFromString(getParsedDate(date));
        setUserFarms(tempRows);
    };

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center card-header">
                    User to Vineyard
                </h2>
                <CardBody>
                    <Row>
                        <Col className="d-flex" sm="6">
                            <FormGroup>
                                <Label className="label" for="userSelect">User</Label>
                                {userListFilter.filteredUserList == undefined && <p><em>Loading...</em></p>}
                                {userListFilter.filteredUserList != undefined && userListFilter.filteredUserList != null &&
                                    <Select style={{ zIndex: "9999" }}
                                        id="userSelect" width="max-content"
                                        name="userSelect"
                                        closeMenuOnSelect={true}
                                        className="dropdown"
                                        placeholder="Select User"
                                        value={userSelect}
                                        options={userListFilter.filteredUserList}
                                        onChange={handleUserChange}
                                        isClearable hideSelectedOptions={false}
                                    />
                                }
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm="1">
                            <Input type="checkbox" checked={masterCheck} id="masterCheck" onChange={(e) => onMasterCheck(e)} disabled={saveDisabled} />&nbsp;&nbsp;&nbsp;&nbsp;Select All
                        </Col>
                        <Col sm="2">
                            <FormGroup>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="Search for vineyard" />
                            </FormGroup>
                        </Col>
                        <Col sm="9">
                            {userFarms.length > 0 &&
                                <>
                                    {saveDisabled ?
                                        <>
                                            <Button onClick={handleSubmit} style={{ float: "right", marginRight: "2vw" }} id="btnSave" className="btn btn-save" color="success" disabled size="sm">
                                                <Row>
                                                    <Col sm="6">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row></Button>{' '}
                                        </>
                                        :
                                        <>
                                            <Button style={{ float: "right", marginRight: "2vw" }} onClick={handleSubmit} id="btnSave" className="btn btn-save" color="success" size="sm">
                                                Save
                                            </Button>{' '}
                                        </>
                                    }
                                </>
                            }


                            {/*<Button disabled={saveDisabled} id="btnSave"  onClick={handleSubmit} className="btn btn-save">Save</Button>*/}
                        </Col>
                    </Row>

                    <Row className="userFarm-tabledetails">
                        <Col>
                            <Table striped bordered hover style={style.table}>
                                <thead style={style.th}>
                                    <tr>
                                        <th style={{ width: "5%", borderWidth: "1px 1px" }} >Vineyard Access</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Vineyard Id</th>
                                        <th style={{ width: "20%", borderWidth: "1px 1px" }} >Vineyard Name</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Role</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Position</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Access Expiry</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userFarms == undefined &&
                                        <tr><td colSpan="3" style={{ textAlign: "center" }}>Loading...</td></tr>
                                    }
                                    {userFarms != undefined && userFarms.length > 0 && userFarms.map((item, idx) => (
                                        <tr key={uuid()}>
                                            <td><Input type="checkbox" checked={item.farmAccess} key={item.farmId} id={"chk_" + item.farmId} onChange={(e) => onItemCheck(e, item, 'farmAccess')} /></td>
                                            <td>{item.farmUniqueIdentifier}</td>
                                            <td>{item.farmname}</td>
                                            <td>
                                                {userFarmList.roleList == undefined && <p><em>Loading...</em></p>}
                                                {userFarmList.roleList != undefined && userFarmList.roleList != null &&
                                                    <Input type="select" disabled={!userFarms[idx].farmAccess} value={userFarms[idx].role} onChange={handleRoleChange(idx)} name="role" id="role">
                                                        {userFarmList.roleList.map(items =>
                                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                                        )}
                                                    </Input>
                                                }
                                            </td>
                                            <td>
                                                {userFarmList.positionList == undefined && <p><em>Loading...</em></p>}
                                                {userFarmList.positionList != undefined && userFarmList.positionList != null &&
                                                    <Input type="select" disabled={!userFarms[idx].farmAccess} value={userFarms[idx].position} onChange={handlePositionChange(idx)} name="position" id="position">
                                                        {userFarmList.positionList.map(items =>
                                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                                        )}
                                                    </Input>
                                                }
                                            </td>
                                            <td>
                                                {item.isInvited &&
                                                        <DatePicker style={{ zIndex: "9999" }} disabled={!userFarms[idx].farmAccess} selected={userFarms[idx].accessExpiry != null ? getDateFromString(moment(userFarms[idx].accessExpiry).format("DD/MM/YYYY")) : null} onChange={(date) => handleAccessExpiryDateChange(idx, date)} name="accessExpiry" dateFormat="dd/MM/yyyy" className="form-control" />    
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}

export default UserVineyard;
